import { asText } from "@prismicio/helpers";
import { useState, useMemo } from "react";
import WvPhotoCarouselPreview from "~/components/molecules/WvPhotoCarouselPreview";
import WvPhotoCarouselSwiper from "~/components/organisms/WvPhotoCarouselSwiper";
import type {  PhotoCarouselWithRichTextSliceTwoColumn } from "prismicio-types";
import type { HTMLComponent } from "@commercekit/react";
import { wrapIframe } from "@commercekit/shared";

const TwoColumnPhotoCarouselWithRichText: HTMLComponent<{
  slice: PhotoCarouselWithRichTextSliceTwoColumn;
}> = ({ slice }) => {

  const [showPreview, setShowPreview] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const images = slice.items.map((item) => item.image);
  const content = useMemo(() => {
    return wrapIframe(asText(slice.primary.content));
  }, [slice.primary.content]);
  return (
    <section className="component-carousel">
      <div className="container pr-lg-5">
        <div className="content">
          {slice.primary.title && slice.primary.title.length > 0 && (
            <h2 className="heading">{asText(slice.primary.title)}</h2>
          )}
        </div>
        <div className="row">
          <div className="col-12 col-lg-6 order-lg-1">

            <WvPhotoCarouselSwiper
              images={images}
              onPreview={(index: number) => {
                setActiveIndex(index);
                setShowPreview(true);
              }}
            />
          </div>
          <div
            className="col-12 col-lg-6 px-lg-5 component-carousel__text content d-flex flex-column justify-content-center align-items-center order-lg-0"
            dangerouslySetInnerHTML={{
              __html: content || "",
            }}
          ></div>
        </div>
      </div>
      {showPreview ? (
        <WvPhotoCarouselPreview
          activeIndex={activeIndex}
          onClose={() => {
            setShowPreview(false);
          }}
          images={images}
        />
      ) : null}
    </section>
  );
};

export default TwoColumnPhotoCarouselWithRichText;
